import React from 'react';
import { PassoExecutado } from '@/models/PassoExecutado';

import { ArtifactFormOverrides } from '@/features/artifacts/components/ArtifactForm/ArtifactForm.types';
import { useArtifactFormConfig } from '@/features/artifacts/hooks/useArtifactFormConfig';
import {
  appointmentDateTimeDisplay,
  appointmentServiceType,
} from '@/features/recursos/agendamentos/helpers';
import {
  Paragraph,
  ShortAnwser,
} from '@/features/artifacts/components/ArtifactForm/ArtifactField.widgets';

import CardSolicitacao, {
  CardSolicitacaoProxyProps,
} from '../../CardSolicitacao';

import { CardItemRenderProps } from '../../CardItem/types';
import SolicitacaoList from '..';

const Form: ArtifactFormOverrides = [
  {
    name: 'reasonCode',
    label: 'Motivo',
    attrs: { autoFocus: true },
    required: true,
    containerStyle: { flex: '0 1 100%' },
    widget: ShortAnwser,
  },
  {
    name: 'startDate',
    label: 'Data',
    required: true,
  },
  { name: 'startTime', label: 'Horário' },
  {
    name: 'description',
    label: 'Observações',
    containerStyle: { flex: '0 1 100%' },
    widget: Paragraph,
  },
];

const CardAgendamento: React.FC<CardSolicitacaoProxyProps> = ({
  solicitacao,
  ...rest
}) => {
  const form = useArtifactFormConfig('agendamento', Form);

  const description = React.useMemo(() => {
    const appointment = solicitacao.pedido as fhir4.Appointment;
    return appointment.description || '';
  }, [solicitacao.pedido]);

  const renderTitle = React.useCallback(
    ({ mode = 'default' }: CardItemRenderProps) => {
      const appointment = solicitacao.pedido as fhir4.Appointment;
      const service = appointmentServiceType(appointment);
      const dateTime = appointmentDateTimeDisplay(appointment);

      if (mode === 'details') {
        return <>{service}</>;
      }

      return (
        <>
          <strong>{service}</strong> | {dateTime}
        </>
      );
    },
    [solicitacao.pedido],
  );

  return (
    <CardSolicitacao
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      title={renderTitle}
      description={description}
      solicitacao={solicitacao}
      form={form}
    />
  );
};

interface Props {
  passo: PassoExecutado;
}
const SolicitacaoListAgendamento: React.FC<Props> = ({ passo }) => {
  return (
    <SolicitacaoList
      passo={passo}
      tipo="agendamento"
      CardSolicitacaoComponent={CardAgendamento}
      groupTitle="Selecione os agendamentos que você quer solicitar no seu prontuário."
      addConfig={{
        title: 'Adicionar agendamento complementar',
      }}
    />
  );
};

export default SolicitacaoListAgendamento;
